import { render, staticRenderFns } from "./AdminDashBoards.vue?vue&type=template&id=70302876&"
import script from "./AdminDashBoards.vue?vue&type=script&lang=js&"
export * from "./AdminDashBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports